import {
    Chevron,
    DropdownButton,
    DropdownWrapper,
    Menu,
    MenuItem,
} from 'components/SalesReport/SalesDropDown/styles';
import { DropdownProps } from 'components/SalesReport/SalesDropDown/types';
import { useEffect, useRef, useState } from 'react';

const SalesDropDown: React.FC<DropdownProps> = ({
    value,
    placeholder = 'Select hour slab',
    options,
    onChange,
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const selected = options.find((o) => o.value === value);

    // close on outside click
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    return (
        <DropdownWrapper ref={ref}>
            <DropdownButton isOpen={open} onClick={() => setOpen(!open)}>
                {selected?.label || placeholder}
                <Chevron isOpen={open} />
            </DropdownButton>

            {open && (
                <Menu>
                    {options.map((opt) => (
                        <MenuItem
                            key={opt.value}
                            active={opt.value === value}
                            onClick={() => {
                                onChange(opt.value);
                                setOpen(false);
                            }}
                        >
                            {opt.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </DropdownWrapper>
    );
};

export default SalesDropDown;
